let url = 'https://ntb-api.liveblog.pro/api/client_blogs?max_results=1000';
const source = `{"query":{"filtered":{"filter":[{"term":{"blog_status":"open"}}]}}}`;
export let fetchFeeds = async () => {
  let res = await fetch(`${url}&source=${encodeURI(source)}`);
  if (!res.ok) {
    const message = `En feil oppstod i NTB Live feed: ${res.status}`;
    throw new Error(message);
  }
  return await res.json();
};
